import { createContext } from 'react';
import { PracticePayersContextProps } from './types';

export const PracticePayersContext = createContext<PracticePayersContextProps>(null!);
